var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "expand_more"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11488_19054",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11488_19054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M8.00011 10.9683C7.91122 10.9683 7.82511 10.9516 7.74178 10.9183C7.65844 10.8849 7.57789 10.8294 7.50011 10.7516L4.48344 7.73494C4.35011 7.60161 4.289 7.43494 4.30011 7.23494C4.31122 7.03494 4.37789 6.87383 4.50011 6.75161C4.64455 6.60717 4.81122 6.53772 5.00011 6.54328C5.189 6.54883 5.35011 6.61828 5.48344 6.75161L8.00011 9.28494L10.5334 6.75161C10.6668 6.61828 10.8251 6.55161 11.0084 6.55161C11.1918 6.55161 11.3557 6.62383 11.5001 6.76828C11.6334 6.90161 11.7001 7.0655 11.7001 7.25994C11.7001 7.45439 11.6334 7.61828 11.5001 7.75161L8.50011 10.7516C8.42233 10.8294 8.34178 10.8849 8.25844 10.9183C8.17511 10.9516 8.089 10.9683 8.00011 10.9683Z",
    fill: "#D3135A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand_more.9784383d4c11ce875504f557affb7589.svg";
export { ForwardRef as ReactComponent };